import { Component, Input, inject } from '@angular/core';
import { AuthService } from '../../../service/auth.service';
import { AuthFlowComponent } from '../../../model/types/auth-flow-component.type';
import { ENVIRONMENT } from '../../../../../environments/environment';
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-form-header',
  templateUrl: './form-header.component.html',
  styleUrl: './form-header.component.scss',
  providers: [],
  standalone: false,
})
export class FormHeaderComponent {
  protected authService = inject(AuthService);

  @Input() parentComponent!: AuthFlowComponent;
  @Input() icon!: string;
  @Input() title!: string;
  @Input() content?: string;
  @Input() staticColor = false; // When true, keeps primary color regardless of form state
  @Input() iconStyle?: string; // Optional override for icon style (e.g., 'fa-thin')

  get iconsStyle(): string {
    return this.iconStyle || ENVIRONMENT.FONTAWESOME.style || 'fal';
  }
}
